import { render, staticRenderFns } from "./VehiclesModuleMenu.vue?vue&type=template&id=56560b41"
import script from "./VehiclesModuleMenu.vue?vue&type=script&lang=js"
export * from "./VehiclesModuleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports